module.exports = __webpack_public_path__ + "images/vervoermaterieelb8f4b3d55cdadc78743013f419c65682.png";